export const TOKEN_KEY = 'token'
export const REFRESH_TOKEN_KEY = 'refresh_token'
export const TOKEN_EXPIRY_KEY = 'token_expiry'

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const removeRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY)
}

export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const setRefreshToken = refreshToken => {
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
}

export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export const getTokenExpiry = () => {
  return localStorage.getItem(TOKEN_EXPIRY_KEY)
}

export const setTokenExpiry = expiryTime => {
  localStorage.setItem(TOKEN_EXPIRY_KEY, expiryTime)
}

export const clearTokenExpiry = () => {
  localStorage.removeItem(TOKEN_EXPIRY_KEY)
}

export const setTokens = ({ token }) => {
  setToken(token?.access)
  setRefreshToken(token?.refresh)
  setTokenExpiry(token?.access_token_exp)
}

export const removeSaveProgressDialogTimeToOpen = () => {
  localStorage.removeItem('saveProgressDialogTimeToOpen')
}

export const clearTokens = () => {
  removeToken()
  removeRefreshToken()
  clearTokenExpiry()
  // remove the save dialog time to open when token is removed
  removeSaveProgressDialogTimeToOpen()
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setToken,
  removeToken,
  getToken,
  setRefreshToken,
  getRefreshToken,
  getTokenExpiry,
  setTokens,
  clearTokens
}
